import { login, logout, getInfo,getUserInformations } from "@/api/user";
import { getToken, setToken, removeToken } from "@/utils/auth";
// import { resetRouter } from "@/router";

const getDefaultState = () => {
    console.log("ready get token from user");
    return {
        token: getToken(),
        name: "",
        avatar: "",
        userInfo: null,
    };
};

const state = getDefaultState();

const mutations = {
    SET_USER_INFORMATION: (state, data) => {
        state.userInfo = data;
    },
    RESET_STATE: (state) => {
        Object.assign(state, getDefaultState());
    },
    SET_TOKEN: (state, token) => {
        state.token = token;
    },
    SET_NAME: (state, name) => {
        state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar;
    }
};

const actions = {
    async getUserInformation({ commit }) {
        let res = await getUserInformations();
        if (res) {
            commit("SET_USER_INFORMATION", res);
        }
    },

    async updateUserPassword({ store, commit }, data) {
        let res = await updateUserPassword(data);

        return res;
    },
    // user login
    login({ commit }, userInfo) {
        const { username, password } = userInfo;
        return new Promise((resolve, reject) => {
            login({ userNameOrEmailAddress: username.trim(), password: password }).then(response => {
                const { accessToken } = response;
                setToken(response);
                commit("SET_TOKEN", accessToken);
                resolve();
            }).catch(error => {
                reject(error);
            });
        });
    },

    // get user info
    getInfo({ commit, state }) {
        return new Promise((resolve, reject) => {
            getInfo(state.token).then(response => {
                if (!response) {
                    reject("Verification failed, please Login again.");
                }

                const { userName } = response;

                commit("SET_NAME", userName);
                // commit('SET_AVATAR', emailAddress)
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },

    // user logout
    logout({ commit, state }) {
        return new Promise((resolve, reject) => {
            removeToken(); // must remove  token  first
            // resetRouter();
            commit("RESET_STATE");
            resolve();
        });
    },

    // remove token
    resetToken({ commit }) {
        return new Promise(resolve => {
        // removeToken() // must remove  token  first
            commit("RESET_STATE");
            resolve();
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/user.js